// Generated by CoffeeScript 1.12.4
(function() {
  var createLink, dereference, inherit, ref1, uniqueMembers;

  ref1 = require('./inherit'), uniqueMembers = ref1.uniqueMembers, inherit = ref1.inherit;

  createLink = require('./util').createLink;

  module.exports = dereference = function(root, dataStructures, known) {
    var i, id, item, j, len, member, newKnown, properties, property, ref, ref2, ref3;
    if (known == null) {
      known = [];
    }
    newKnown = known;
    id = (ref2 = root.meta) != null ? ref2.id : void 0;
    if (typeof id === 'object') {
      id = id.content;
    }
    if (known.indexOf(root.element) !== -1 || known.indexOf(id) !== -1) {
      createLink(root, {
        relation: 'origin',
        href: 'http://refract.link/circular-reference/'
      });
      return root;
    } else if (id != null) {
      newKnown = known.concat(id);
    }
    switch (root.element) {
      case 'enum':
      case 'array':
        root.content = (function() {
          var j, len, ref3, results;
          ref3 = root.content || [];
          results = [];
          for (j = 0, len = ref3.length; j < len; j++) {
            item = ref3[j];
            results.push(dereference(item, dataStructures, newKnown));
          }
          return results;
        })();
        return root;
      case 'object':
        properties = root.content ? root.content.slice(0) : [];
        i = 0;
        while (i < properties.length) {
          member = properties[i];
          i++;
          if (member.element === 'ref') {
            i--;
            ref = dataStructures[member.content.href];
            if (!ref) {
              return root;
            }
            ref.content = JSON.parse(JSON.stringify(ref.content));
            ref3 = ref.content;
            for (j = 0, len = ref3.length; j < len; j++) {
              property = ref3[j];
              createLink(property, {
                relation: 'origin',
                href: 'http://refract.link/included-member/'
              });
              property.meta.ref = member.content.href;
            }
            properties.splice.apply(properties, [i, 1].concat(ref.content));
            continue;
          }
          if (member.content.key) {
            member.content.key = dereference(member.content.key, dataStructures, newKnown);
          }
          if (member.content.value) {
            member.content.value = dereference(member.content.value, dataStructures, newKnown);
          }
        }
        root.content = uniqueMembers(properties);
        return root;
      default:
        ref = dataStructures[root.element];
        if (ref) {
          return dereference(inherit(ref, root), dataStructures, known.concat(root.element));
        } else {
          return root;
        }
    }
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./~/eidolon/lib/dereference.js
// module id = 78
// module chunks = 0